import React from "react";

import { bodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  return (
    <div style={bodyTextStyle}>
      Wait {node.node_data.time_units} {node.node_data.time_unit}
    </div>
  );
};
